import React from 'react';
import { ConfirmDialog } from '@personal-dashboard/ui';

interface DeleteEventDialogProps {
  open: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteEventDialog: React.FC<DeleteEventDialogProps> = ({
  open,
  loading,
  onConfirm,
  onCancel,
}) => {
  return (
    <ConfirmDialog
      open={open}
      title="Delete Event Series"
      message="Delete this event and all its occurrences in the series?"
      confirmLabel="Delete"
      severity="error"
      loading={loading}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default DeleteEventDialog;
